<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'time-tracking.confirmDeleteTimesheetEntry' | appTranslate }}</p>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event" [terminateUrl]="['../', 'terminate']">
        <div *ngIf="timeTrackingAdmin" class="flex buttons">
            <ui-button type="outline" [matMenu]="exportMenu">
                {{ 'export' | appTranslate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv', 'csv')">{{ 'export-as-csv' | appTranslate }}</button>
                <button mat-menu-item (click)="onExport('xlsx', 'excel')">{{ 'export-as-xlsx' | appTranslate }}</button>
            </mat-menu>
            <ui-button (click)="routeTo()" type="primary">{{ 'time-tracking.enterHours' | appTranslate }}</ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <ui-card [withSpacing]="false" [withMargin]="false">
                <app-table
                    *ngIf="table"
                    [table]="table"
                    (menuItemSelected)="menuAction($event)"
                    (action)="onAction($event)"
                    [isResponsive]="true"
                    [embedded]="true"
                    [noPadding]="true"
                    [useStickyHeader]="false"
                    [showOffset]="false"
                >
                    <app-empty-state
                        label="{{
                            table.isEmpty
                                ? 'time-tracking.timesheetsIndexPage.noTimesheets'
                                : ('time-tracking.timesheetsIndexPage.noTimesheetsInFilter' | appTranslate)
                        }}"
                        src="/assets/illustrations/empty-box.png"
                    ></app-empty-state>
                </app-table>
            </ui-card>
        </div>
    </div>
</div>
